export default {
  form: {
    versions: {
      label: 'Version',
      placeholder: 'Vælg version',
    },
    font_family: {
      label: 'Skrifttype',
    },
    background_color: {
      label: 'Baggrundsfarve',
    },
    promo_frame_primary_color: {
      label: 'Farve på kampagneramme',
    },
    promo_frame_discount_label_color: {
      label: 'Rabatfarve på kampagneramme',
    },
    vip_members_cta_color: {
      label: 'Farve på VIP-medlemmers CTA',
    },
    url_cta_color: {
      label: 'URL-CTA-farbe',
    },
    url_color: {
      label: 'URL-farve',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Vælg URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'Farve på QR-kodens kant',
    },
    qr_code_background_color: {
      label: 'Baggrundsfarve på QR-kode',
    },
    footer_background_color: {
      label: 'Baggrundsfarve på sidefod',
    },
    logo_zoom: {
      label: 'Logostørrelse',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Klistermærket kunne ikke indlæses',
  },
};
